import React from 'react'
import { Route, Switch } from 'react-router-dom'
import RouteApp from 'routes/app'
import RouteSetToken from './routes/set-token'
import RouteLogout from 'routes/logout'
import RouteAdmin from 'routes/admin'
import RouteUnauthorized from 'routes/unauthorized'
import WhenRestored from 'components/WhenRestored'
import CurrentUserProvider from 'components/CurrentUserProvider'
import UploadsProvider from 'components/UploadsProvider'
import ErrorBoundary from 'components/ErrorBoundary'

const App = () => (
  <ErrorBoundary>
    <WhenRestored>
      <CurrentUserProvider>
        <UploadsProvider>
          <Switch>
            <Route path="/set-token" component={RouteSetToken} />
            <Route path="/logout" component={RouteLogout} />
            <Route path="/admin" component={RouteAdmin} />
            <Route path="/unauthorized" component={RouteUnauthorized} />
            <Route path="/" component={RouteApp} />
          </Switch>
        </UploadsProvider>
      </CurrentUserProvider>
    </WhenRestored>
  </ErrorBoundary>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js